<div class="step-header" *ngIf="!wizardCtrl.getWizardService().isLoading">
  <div class="title">Review</div>
</div>
<div class="content" *ngIf="!wizardCtrl.getWizardService().isLoading">
  <div class="datasource-settings-container">
    <div class="header">
      <div class="icon">
        <img width="50" src="{{step.parent.output.datasourceType.iconSrc}}" />
      </div>
      <div class="title">{{step.parent.output.datasourceType.label}}</div>
    </div>
    <div class="datasource">
      <div class="header">
        <div class="icon">
          <mat-icon>settings</mat-icon>
        </div>
        <div class="label">Definition</div>
      </div>

      <div class="datasource-settings">
        <div class="alias-input" *ngIf="!editAlias">
          <div class="key">Alias:</div>
          <div class="value label">{{alias}}</div>
          <div class="edit" (click)="makeEditAlias()">EDIT</div>
        </div>

        <div class="alias-input" *ngIf="editAlias">
          <form novalidate #currentForm="ngForm">
            <div class="key">Alias: *</div>
            <div>
              <input
                autocomplete="off"
                placeholder="Enter name"
                class="value"
                name="alias"
                [(ngModel)]="alias"
                (ngModelChange)="onAliasChange()"
                maxlength="40"
                #aliasInput="ngModel"
                required
              />
              <div
                class="error"
                *ngIf="aliasInput.invalid && (aliasInput.dirty || aliasInput.touched)"
              >
                <mat-error *ngIf="aliasInput.errors.maxlength">Name is too long.</mat-error>
                <mat-error *ngIf="aliasInput.errors.required">Name is required.</mat-error>
              </div>
              <div class="error" *ngIf="nameExist">
                <mat-error>Name already exist</mat-error>
              </div>
            </div>
            <div class="edit" (click)="aliasUpdated()" *ngIf="aliasInput.valid && !nameExist">
              SAVE
            </div>
          </form>
        </div>
      </div>
      <div class="datasource-settings">
        <div class="key">Agent type:</div>
        <div class="value label">{{agentType}} agent</div>
      </div>
    </div>
    <div class="datasource">
      <div class="header">
        <div class="icon"><img src="images/site.svg" /></div>
        <div class="label">Site information</div>
        <div class="edit" (click)="wizardCtrl.editSite()">EDIT</div>
      </div>
      <div class="datasource-settings">
        <div class="key">Name:</div>
        <div class="value label">
          <div class="name">{{step.parent.output.siteName}}</div>
        </div>
      </div>
      <div class="datasource-settings">
        <div class="key">Location:</div>
        <div class="value label">
          <div class="city">{{locationName}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="wizardCtrl.getWizardService().isLoading" class="loader">
  <div class="loader-msg-header">
    <p>Updating {{step.parent.output.datasourceType.label}}</p>
  </div>
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
